<div class="feedback-dialog__header"
     mat-dialog-title>

    <h2>{{ 'feedback-dialog.title' | translate }}</h2>

    <button (click)="selfDialogRef.close()"
            aria-label="close dialog"
            class="close">
        <mat-icon svgIcon="cross"></mat-icon>
    </button>

</div>

<mat-dialog-content class="feedback-dialog__content">

    <form class="feedback-dialog__form"
          [formGroup]="form">
        <div class="feedback-dialog__fieldset-wrapper">
            <fieldset class="feedback-dialog__fieldset">
                <legend class="feedback-dialog__legend">
                    {{ 'feedback-dialog.ranking' | translate }}
                </legend>
                <div class="feedback-dialog__radio-group feedback-dialog__grade-radio-group">
                    <label class="feedback-dialog__radio-button"
                           aria-label="1">
                        <input formControlName="grade"
                               id="grade-1"
                               name="grade"
                               type="radio"
                               value="1"
                        />
                        <mat-icon svgIcon="feedback-dialog__star"></mat-icon>
                    </label>
                    <label class="feedback-dialog__radio-button"
                           aria-label="2">
                        <input formControlName="grade"
                               id="grade-2"
                               name="grade"
                               type="radio"
                               value="2"
                        />
                        <mat-icon svgIcon="feedback-dialog__star"></mat-icon>
                    </label>
                    <label class="feedback-dialog__radio-button"
                           aria-label="3">
                        <input formControlName="grade"
                               id="grade-3"
                               name="grade"
                               type="radio"
                               value="3"
                        />
                        <mat-icon svgIcon="feedback-dialog__star"></mat-icon>
                    </label>
                    <label class="feedback-dialog__radio-button"
                           aria-label="4">
                        <input formControlName="grade"
                               id="grade-4"
                               name="grade"
                               type="radio"
                               value="4"
                        />
                        <mat-icon svgIcon="feedback-dialog__star"></mat-icon>
                    </label>
                    <label class="feedback-dialog__radio-button"
                           aria-label="5">
                        <input formControlName="grade"
                               id="grade-5"
                               name="grade"
                               type="radio"
                               value="5"
                        />
                        <mat-icon svgIcon="feedback-dialog__star"></mat-icon>
                    </label>
                </div>
            </fieldset>
        </div>
        <div class="feedback-dialog__fieldset-wrapper">
            <fieldset class="feedback-dialog__fieldset">
                <legend class="feedback-dialog__legend">
                    {{ 'feedback-dialog.recommandation' | translate }}
                </legend>
                <div class="feedback-dialog__nps">
                    <mat-radio-group class="feedback-dialog__nps-radio-group"
                                     formControlName="recommendation">
                        <!-- First subgroup of radio buttons (from 0 through 5) -->
                        <div class="feedback-dialog__nps-radio-subgroup">
                            <mat-radio-button *ngFor="let number of [0, 1,2,3,4,5]"
                                            class="feedback-dialog__nps-radio-button"
                                            [class.feedback-dialog__nps-radio-button--checked]="form.get('recommendation').value === number"
                                            [value]="number">
                                <span class="feedback-dialog__nps-radio-button-number-label">{{ number }}</span>
                                <!-- If no radio button is checked OR if first radio button (0) is checked -->
                                <ng-container *ngIf="form.get('recommendation').value === '' || form.get('recommendation').value === number">
                                    <span *ngIf="number === 0"
                                        class="feedback-dialog__nps-radio-button-text-label"
                                        [@fadeInAndOut]>
                                        {{ "nps.absolutely_not" | translate }}
                                    </span>
                                </ng-container>
                                <!-- If one radio button from 1 through 5 is checked -->
                                <ng-container *ngIf="form.get('recommendation').value === number">
                                    <span *ngIf="number >= 1 && number <= 3"
                                        class="feedback-dialog__nps-radio-button-text-label"
                                        [@fadeInAndOut]>
                                        {{ "nps.absolutely_not" | translate }}
                                    </span>
                                    <span *ngIf="number >= 4 && number <= 5"
                                        class="feedback-dialog__nps-radio-button-text-label"
                                        [@fadeInAndOut]>
                                        {{ "nps.i_dont_think_so" | translate }}
                                    </span>
                                </ng-container>
                            </mat-radio-button>
                        </div>
                        <!-- Second subgroup of radio buttons (from 6 through 10) -->
                        <div class="feedback-dialog__nps-radio-subgroup">
                            <mat-radio-button *ngFor="let number of [6,7,8,9,10]"
                                            class="feedback-dialog__nps-radio-button"
                                            [class.feedback-dialog__nps-radio-button--checked]="form.get('recommendation').value === number"
                                            [value]="number">
                                <span class="feedback-dialog__nps-radio-button-number-label">{{ number }}</span>
                                <!-- If one radio button from 6 through 9 is checked -->
                                <ng-container *ngIf="form.get('recommendation').value === number">
                                    <span *ngIf="number === 6"
                                        class="feedback-dialog__nps-radio-button-text-label"
                                        [@fadeInAndOut]>
                                        {{ "nps.i_dont_think_so" | translate }}
                                    </span>
                                    <span *ngIf="number >= 7 && number <= 8"
                                        class="feedback-dialog__nps-radio-button-text-label"
                                        [@fadeInAndOut]>
                                        {{ "nps.maybe" | translate }}
                                    </span>
                                    <span *ngIf="number === 9"
                                        class="feedback-dialog__nps-radio-button-text-label"
                                        [@fadeInAndOut]>
                                        {{ "nps.absolutely" | translate }}
                                    </span>
                                </ng-container>
                                <!-- If no radio button is checked OR if last radio button (10) is checked -->
                                <ng-container *ngIf="form.get('recommendation').value === '' || form.get('recommendation').value === number">
                                    <span *ngIf="number === 10"
                                        class="feedback-dialog__nps-radio-button-text-label"
                                        [@fadeInAndOut]>
                                        {{ "nps.absolutely" | translate }}
                                    </span>
                                </ng-container>
                            </mat-radio-button>
                        </div>
                    </mat-radio-group>
                </div>
            </fieldset>
        </div>
        <div class="feedback-dialog__fieldset-wrapper">
            <fieldset class="feedback-dialog__fieldset">
                <legend class="feedback-dialog__legend">
                    {{ 'feedback-dialog.before_activities' | translate }}
                </legend>
                <div class="feedback-dialog__radio-group feedback-dialog__interest-radio-group">
                    <label class="feedback-dialog__radio-button">
                        <input formControlName="before"
                               id="before-1"
                               name="before"
                               type="radio"
                               value="1"
                        />
                        <div>{{ 'feedback-dialog.labels_0' | translate }}</div>
                    </label>
                    <label class="feedback-dialog__radio-button">
                        <input formControlName="before"
                               id="before-2"
                               name="before"
                               type="radio"
                               value="2"
                        />
                        <div>{{ 'feedback-dialog.labels_1' | translate }}</div>
                    </label>
                    <label class="feedback-dialog__radio-button">
                        <input formControlName="before"
                               id="before-3"
                               name="before"
                               type="radio"
                               value="3"
                        />
                        <div>{{ 'feedback-dialog.labels_2' | translate }}</div>
                    </label>
                    <label class="feedback-dialog__radio-button">
                        <input formControlName="before"
                               id="before-4"
                               name="before"
                               type="radio"
                               value="4"
                        />
                        <div>{{ 'feedback-dialog.labels_3' | translate }}</div>
                    </label>
                    <label class="feedback-dialog__radio-button">
                        <input formControlName="before"
                               id="before-5"
                               name="before"
                               type="radio"
                               value="5"
                        />
                        <div>{{ 'feedback-dialog.labels_4' | translate }}</div>
                    </label>
                </div>
            </fieldset>
        </div>
        <div class="feedback-dialog__fieldset-wrapper">
            <fieldset class="feedback-dialog__fieldset">
                <legend class="feedback-dialog__legend">
                    {{ 'feedback-dialog.after_activities' | translate }}
                </legend>
                <div class="feedback-dialog__radio-group feedback-dialog__interest-radio-group">
                    <label class="feedback-dialog__radio-button">
                        <input type="radio"
                               id="after-1"
                               formControlName="after"
                               name="after"
                               value="1"
                        />
                        <div>{{ 'feedback-dialog.labels_0' | translate }}</div>
                    </label>
                    <label class="feedback-dialog__radio-button">
                        <input type="radio"
                                id="after-2"
                                formControlName="after"
                                name="after"
                                value="2"
                        />
                        <div>{{ 'feedback-dialog.labels_1' | translate }}</div>
                    </label>
                    <label class="feedback-dialog__radio-button">
                        <input type="radio"
                                id="after-3"
                                formControlName="after"
                                name="after"
                                value="3"
                        />
                        <div>{{ 'feedback-dialog.labels_2' | translate }}</div>
                    </label>
                    <label class="feedback-dialog__radio-button">
                        <input type="radio"
                                id="after-4"
                                formControlName="after"
                                name="after"
                                value="4"
                        />
                        <div>{{ 'feedback-dialog.labels_3' | translate }}</div>
                    </label>
                    <label class="feedback-dialog__radio-button">
                        <input type="radio"
                                id="after-5"
                                formControlName="after"
                                name="after"
                                value="5"
                        />
                        <div>{{ 'feedback-dialog.labels_4' | translate }}</div>
                    </label>
                </div>
            </fieldset>
        </div>
        <div class="feedback-dialog__fieldset-wrapper">
            <fieldset class="feedback-dialog__fieldset">
                <legend class="feedback-dialog__legend">
                    {{ 'feedback-dialog.genre_activities' | translate }}
                </legend>
                <div class="feedback-dialog__radio-group feedback-dialog__gender-radio-group">
                    <label class="feedback-dialog__radio-button">
                        <input type="radio"
                               id="boy"
                               formControlName="genre"
                               name="genre"
                               value="boy"
                        />
                        <div>{{ 'feedback-dialog.genre.boy' | translate }}</div>
                    </label>
                    <label class="feedback-dialog__radio-button">
                        <input type="radio"
                               id="girl"
                               formControlName="genre"
                               name="genre"
                               value="girl"
                        />
                        <div>{{ 'feedback-dialog.genre.girl' | translate }}</div>
                    </label>
                    <label class="feedback-dialog__radio-button">
                        <input type="radio"
                               id="unknow"
                               formControlName="genre"
                               name="genre"
                               value="unknow"
                        />
                        <div>{{ 'feedback-dialog.genre.unknow' | translate }}</div>
                    </label>
                </div>
            </fieldset>
        </div>
        <div class="feedback-dialog__field-wrapper">
            <label for="textarea">
                {{'feedback-dialog.feedback' | translate}}
            </label>
            <textarea formControlName="feedback"
                      id="textarea"
                      rows="4"
                      maxlength="280">
            </textarea>
        </div>
    </form>

    <div class="feedback-dialog__actions"
        mat-dialog-actions>
        <button (click)="onSubmit()">
            <span>{{ 'feedback-dialog.submit' | translate }}</span>
        </button>
    </div>

</mat-dialog-content>